import { Role } from "src/Api/Enum/Role";
import { adminPermission } from "./adminPermission";
import { plannerPermission } from "./plannerPermission";
import { analystPermission } from "./analystiPermission";
import { partnerPermission } from "./partnerPermission";
import { superUserPermission } from "./superUserPermission";
import type { CustomerPermission, TablePermission } from "./permission";

export const rolePermission: Record<Role, (customerPermissions?: CustomerPermission[], userRoles?: string[]) => TablePermission> = {
    [Role.SUPER_ADMIN]: () => ({}),
    
    [Role.ADMIN]: (customerPermissions: CustomerPermission[] = [], userRoles: string[] = []) =>
        adminPermission(customerPermissions, userRoles),
    
    [Role.PLANNER]: (customerPermissions: CustomerPermission[] = [], userRoles: string[] = []) =>
        plannerPermission(customerPermissions, userRoles),
        
    [Role.ANALYST]: (customerPermissions: CustomerPermission[] = [], userRoles: string[] = []) =>
        analystPermission(customerPermissions, userRoles),
                  
    [Role.PARTNER]: (customerPermissions: CustomerPermission[] = [], userRoles: string[] = []) =>
        partnerPermission(customerPermissions, userRoles),
        
    [Role.SUPER_USER]: (customerPermissions: CustomerPermission[] = [], userRoles: string[] = []) =>
        superUserPermission(customerPermissions, userRoles),
                            
    [Role.SENSOR]: () => ({}),
};